import * as e from "react";
import { useLayoutEffect as f } from "react";
var n = function(a) {
  return a();
}, t = e["useInsertionEffect"] ? e["useInsertionEffect"] : !1, c = t || n, o = t || f;
export {
  c as useInsertionEffectAlwaysWithSyncFallback,
  o as useInsertionEffectWithLayoutFallback
};
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.browser.esm.js.map
